import { Commande } from 'src/app/models/Commande';
import { Utils } from './../../../utils';
import { ImageComponent } from './../../image/image.component';
import { CommandeService } from './../../../services/commande.service';
import { StoreService } from './../../../services/store.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectItem, Message } from 'primeng/primeng';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-viewcommande',
  templateUrl: './viewcommande.component.html',
  styleUrls: ['./viewcommande.component.css']
})
export class ViewcommandeComponent implements OnInit {
  titre = 'Validation commande';
  commande: any;
  displayCategorie: boolean;
  displayNafama: boolean;
  typeCommande: string;
  colorFieldset = 'primary';
  colorPanel = 'primary';
  profil = 'adv';
  itemPaiements: any[] = [];
  itemDepots: any[] = [];
  listBanque: SelectItem[] = [];
  listModeReglement: SelectItem[] = [];
  listProduits: SelectItem[] = [];
  fr = {
    firstDayOfWeek: 0,
    monthNames: [
      'Janvier', 'Février', 'Mars',
      'Avril', 'Mai', 'Juin',
      'Juillet', 'Août', 'Septembre',
      'Octobre', 'Novembre', 'Décembre'
    ],
    monthNamesShort: ['Janv.', 'Févr.', 'Mars', 'Avr.', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
    dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    dayNamesShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'],
    dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S']
  };
  today: any = new Date();
  commandeForm: FormGroup;
  msgs: Message[] = [];
  uploadedFiles: any[] = [];
  categoriePiece: string;
  readOnlyOracle: any;
  readOnlyOracleCompta: any;
  referenceOracle: string;
  commentaire: string;
  produitOracle: any;
  listProduitOracle: any = [];
  sommeTotalProduit = 0;
  sommeTotalProduitOracle = 0;
  @ViewChild(ImageComponent, { static: false }) image: ImageComponent;
  images = [];
  constructor(
    private activatedRoute: ActivatedRoute,
    private store: StoreService,
    private formBuilder: FormBuilder,
    public commandeService: CommandeService,
    private route: Router,
    public authService: AuthService
  ) { }

  async ngOnInit() {
    /*
    if (this.store.tmp.commande) {
      this.commande = this.store.tmp.commande;
      console.log('this.commande.typeCommande: ', this.commande.typeCommande);
      this.sommeTotalProduit = this.commande.listProduit.length === 0 ? 0 : this.commande.listProduit.map(e => this.commande.typeCommande.toLowerCase() === 'produits' ? e.montant * e.quantite : e.montant).reduce((t, e) => t + e);
      console.log('this.commande.piecesJointes: ', this.image, this.commande.piecesJointes);
      // this.image.clearFileNames();
      // this.image.addFileNames(this.printFileName(this.commande.piecesJointes));
      this.images = this.printFileName(this.commande.piecesJointes).split(';').filter(e => e.trim()).map(e => Utils.newGalleryImage(e));
    } else {
      this.activatedRoute.queryParamMap.subscribe(params => {
        const id = params.get('id');
        if (!id) {
          return window.history.back();
        }
        console.log('id: ', id);
        this.loadCommande(id);
      });
    }
    */

    this.activatedRoute.queryParamMap.subscribe(params => {
      const id = params.get('id');
      if (!id) {
        return window.history.back();
      }
      console.log('id: ', id);
      this.loadCommande(id);
    });
    
  }

  displayImage:boolean;
  private async loadCommande(id: any) {
    this.commande = await this.commandeService.commande(id).toPromise();
    console.log('this.commande.typeCommande: ', this.commande.typeCommande);
    this.sommeTotalProduit = this.commande.listProduit.length === 0 ? 0 : this.commande.listProduit.map(e => this.commande.typeCommande.toLowerCase() === 'produits' ? e.montant * e.quantite : e.montant).reduce((t, e) => t + e);
    console.log('this.commande.piecesJointes: ', this.commande.piecesJointes);
    // this.image.clearFileNames();
    // this.image.addFileNames(this.printFileName(this.commande.piecesJointes));
    this.images = this.printFileName(this.commande.piecesJointes).split(';').map(e => Utils.newGalleryImage(e));
    console.log('==============image=============', this.images);
    this.displayImage=true;
  }


  retour() {
    this.displayCategorie = true;
    this.displayNafama = false;
  }

  async loadOracle() {
    this.produitOracle = await this.commandeService.getOracleData(this.referenceOracle).toPromise();
    console.log('oracles**********: ', this.produitOracle);
    this.sommeTotalProduitOracle = this.produitOracle.length === 0 ? 0 : this.produitOracle.map(e => e.fulfield_quantity * e.unit_selling_pricing).reduce((t, e) => t + e);

  }


  async chargerOracle(role: string) {
    let reference: any;
    if (role === 'ADV') {
      reference = this.commande.referenceOracle;
    } else {
      reference = this.commande.referenceOracleCompta;
    }
    this.listProduitOracle = await this.commandeService.getOracleData(reference).toPromise();
    //this.listProduitOracle = await this.commandeService.getOracleData(reference).toPromise();
    console.log('oracles**********: ', this.produitOracle);
    this.sommeTotalProduitOracle = this.listProduitOracle.length === 0 ? 0 : this.listProduitOracle.map(e => e.fulfield_quantity * e.unit_selling_pricing).reduce((t, e) => t + e);
  }

  async validerCommande() {
    if (this.commentaire == null || this.commentaire === undefined || this.commentaire === '') {
      this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Le commentaire est obligatoire !!!' });
      return;
    }
    await this.commandeService.next(
      this.commande.id,
      {
        pieces: this.uploadedFiles,
        commentaire: this.commentaire,
        referenceOracle: this.referenceOracle
      })
      .toPromise();
    this.msgs = [];
    this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Traitement effectué avec succès' });
    this.route.navigateByUrl('/root/list-commande');
  }
  async rejeterCommande() {
    if (this.commentaire == null || this.commentaire === undefined || this.commentaire === '') {
      this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Le commentaire est obligatoire !!!' });
      return;
    }
    await this.commandeService.previous(this.commande.id,
      { pieces: this.uploadedFiles, commentaire: this.commentaire, referenceOracle: this.referenceOracle }
    ).toPromise();
    this.msgs = [];
    this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Traitement effectué avec succès' });
    this.route.navigateByUrl('/root/list-commande');
  }

  initForm() {
    this.commandeForm = this.formBuilder.group({
      referenceOracle: [this.commande && this.commande.referenceOracle, [Validators.required]],
    });
  }
  actualiser() {
    this.ngOnInit();
  }
  exportCharges() {
  }

  printFileName(names: string): string {
    const images = names.split(';').filter(e => e).map(a => a + '.jpg').join(';');
    console.log('images::', images);
    return images;
  }

  async detectFiles0(event) {
    console.log('files: ', event.target.files);
    const files = [];
    for (let i = 0; i < event.target.files.length; i++) {
      files.push(event.target.files[i]);
    }
    await Promise.all(files.map(async file => {
      try {
        this.uploadedFiles.push({
          nom: (await this.commandeService.sendToOpenStack(file, files.indexOf(file)).toPromise() as any).message,
          categorie: this.categoriePiece,
          agent: this.authService.currentUser.login,
          profil: this.authService.currentUser.role
        });
      } catch (error) {
      }
    }));
    console.log('uploadedFiles: ', this.uploadedFiles);
  }
}
